import { Link, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { Button } from '@peacecover/component';
import ProfileAvatar from '../../my-page/components/ProfileAvatar';
import TradingPhotoCard from './TradingPhotoCard';
import { confirmReview } from '../apis/reviewStatusMutation';
import type { TradingPhotoCardType } from '../../trading/types/TradingPhotoCardType';

const TradeCompleteRequest = ({ tradingPhotoCard }: { tradingPhotoCard: TradingPhotoCardType }) => {
  const navigate = useNavigate();

  const handleAcceptReview = async () => {
    try {
      const response = await confirmReview(tradingPhotoCard.tradingPhotoCardId);
      if (response.ok) {
        navigate(
          `/reviews/add-review?reviewableId=${tradingPhotoCard.tradingPhotoCardId}&reviewableType=TradingPhotoCard`
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center gap-[6px] mt-[32px]">
        <ProfileAvatar
          thumbnailUrl={
            tradingPhotoCard.userProfile.thumbnailUrl || tradingPhotoCard.userProfile.pictureUrl
          }
          widthAndHeight="32px"
          svgWidthAndHeight="32px"
        />
        <p className="text-[15px] font-semibold text-text-main-lv2 leading-none max-w-[166px] truncate">
          {tradingPhotoCard.userProfile.nickname}
        </p>
      </div>
      <h1 className="text-[26px] font-semibold text-text-main-lv2 mt-[24px]">
        {t('TradeReviewRequestPage.tradingCompleteRequestTitle')}
      </h1>
      <p className="text-center text-[17px] font-medium text-text-main-lv3 mt-[10px] whitespace-pre-line leading-tight">
        {t('TradeReviewRequestPage.tradingCompleteRequestDescription')}
      </p>
      <div className="w-full px-[24px] mt-[48px] flex flex-col items-center">
        <TradingPhotoCard photoCard={tradingPhotoCard.photoCard} />
      </div>
      <div className="absolute bottom-[46px] flex flex-col items-center gap-[32px] w-full px-[24px]">
        <Button
          size="large"
          className="w-full text-[17px] font-semibold"
          onClick={handleAcceptReview}
        >
          {t('TradeReviewRequestPage.completeTradeAndReview')}
        </Button>
        <Link to="/feed" className="text-[15px] font-medium text-text-main-lv3 leading-none">
          {t('TradeReviewRequestPage.noTradeWithThisPerson')}
        </Link>
      </div>
    </div>
  );
};

export default TradeCompleteRequest;
